import React, { ComponentPropsWithoutRef, FC } from 'react';
import cx from 'classnames';

import styles from './styles.module.css';

import Filters from './Filters';
import Table from './Table';

type TableViewProps = ComponentPropsWithoutRef<'div'>;

const TableView: FC<TableViewProps> = ({ className, ...props }) => (
  <div className={cx(styles.root, className)} {...props} />
);

export default Object.assign(TableView, { Filters, Table });
